<script>
import TestInput from "../../../components/shared/testInput.vue";
import Dropdown from "@/components/dropdown.vue";
import FileInput from "@/components/shared/FileInput.vue";
import Questionmark from "@/components/questionmark.vue";
import FileDisplay from "../../../components/shared/FileDisplay.vue";
export default {
  props: {
    emailTaken: {
      type: Boolean,
      required: false,
      default: false
    },
    pibTaken: {
      type: Boolean,
      required: false,
      default: false
    },
    idTaken: {
      type: Boolean,
      required: false,
      default: false
    },
    usernameTaken: {
      type: Boolean,
      default: false
    },
    type: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    },
    organisationType: {
      type: Array,
      required: true
    },
    countries: {
      type: Array
    }
  },
  components: {
    InputView: TestInput,
    Dropdown,
    Questionmark,
    FileDisplay,
    FileInput
  },
  data() {
    return {
      confirmPassword: "",
      userLocal: { ...this.user },
      acceptRules: false
    };
  },
  watch: {
    user(val) {
      this.userLocal = { ...val };
    }
  },
  methods: {
    clearError(field) {
      this.$emit("clear-error", field);
    },
    handlePhoneNumber(field, number, e) {
      const val = number
        .replace(/(?!^\+)[^0-9 ]/g, "")
        .replace(/[ ]{2,}/g, " ");
      this.$set(this.userLocal, field, val);
      e.target.value = val;
      this.updateUser(field);
    },
    updateUser(field) {
      this.clearError(field);
      this.$emit("update", this.userLocal);
    },
    handleFiles(files, field) {
      this.$set(this.userLocal, field, files[0]);
      this.updateUser(field);
    },
    handleRemoveFile(field) {
      this.$set(this.userLocal, field, null);
      this.updateUser(field);
    }
  }
};
</script>
<template>
  <div class="register-subpage">
    <div class="inputs">
      <div class="input-wrapper">
        <span class="label">{{ $t("main.inputsRequired") }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.org_pib"
          type="text"
          :label="$t('main.pib') + (type ? ' *' : '')"
          @input="updateUser('org_pib')"
        />
        <span v-if="errors.org_pib" class="error">
          {{ $t("errors.registration.pib") }}
        </span>
        <span v-if="pibTaken" class="error">{{
          $t("errors.registration.pibTaken")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.org_id"
          type="text"
          :label="$t('main.mbf') + (type ? ' *' : '')"
          @input="updateUser('org_id')"
        />
        <span v-if="errors.org_id" class="error">
          {{ $t("errors.registration.mb") }}
        </span>
        <span v-if="pibTaken" class="error">{{
          $t("errors.registration.idTaken")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_org_registration_number"
          type="text"
          :label="$t('main.usr_org_registration_number') + (type ? ' *' : '')"
          @input="updateUser('usr_org_registration_number')"
        />
        <span v-if="errors.usr_org_registration_number" class="error">
          {{ $t("errors.registration.usr_org_registration_number") }}
        </span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_org_bank"
          type="text"
          :label="$t('main.usr_org_bank') + (type ? ' *' : '')"
          @input="updateUser('usr_org_bank')"
        />
        <span v-if="errors.usr_org_bank" class="error">
          {{ $t("errors.registration.usr_org_bank") }}
        </span>
      </div>
      <div class="input-wrapper">
        <div class="questionmark-wrap">
          <span>{{
            $t("main.usr_business_register") + (type ? " *" : "")
          }}</span>
          <questionmark :id="57" :toast="true" />
        </div>
        <FileInput @change="handleFiles($event, 'usr_business_register')" />
        <FileDisplay
          v-if="userLocal.usr_business_register"
          :fileName="userLocal.usr_business_register.name"
          @remove-file="handleRemoveFile('usr_business_register')"
        />
        <span v-if="errors.usr_business_register" class="error">{{
          $t("errors.registration.usr_business_register")
        }}</span>
      </div>
      <div class="input-wrapper">
        <div class="questionmark-wrap">
          <span>{{ $t("main.file") }}</span>
          <questionmark :id="58" :toast="true" />
        </div>
        <FileInput @change="handleFiles($event, 'usr_tax_info')" />
        <FileDisplay
          v-if="userLocal.usr_tax_info"
          :fileName="userLocal.usr_tax_info.name"
          @remove-file="handleRemoveFile('usr_tax_info')"
        />
        <span v-if="errors.usr_tax_info" class="error">{{
          $t("errors.registration.usr_tax_info")
        }}</span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.org_services"
          type="text"
          :label="$t('main.firmField')"
          @input="updateUser('org_services')"
        />
        <span v-if="errors.org_services" class="error">
          {{ $t("errors.registration.orgType") }}
        </span>
      </div>
      <div class="input-wrapper" v-if="countries">
        <dropdown
          :defaultText="$t('main.firmType') + (type ? ' *' : '')"
          :selected="userLocal.org_type"
          :list="organisationType"
          @changeOption="(userLocal.org_type = $event), updateUser('org_type')"
        />
        <span v-if="errors.org_type" class="error">
          {{ $t("errors.registration.orgType") }}
        </span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_org_contact_person"
          type="text"
          :label="$t('main.usr_org_contact_person') + (type ? ' *' : '')"
          @input="updateUser('usr_org_contact_person')"
        />
        <span v-if="errors.usr_org_contact_person" class="error">
          {{ $t("errors.registration.usr_org_contact_person") }}
        </span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.org_contact"
          type="text"
          :label="$t('main.orgContact') + (type ? ' *' : '')"
          @input="updateUser('org_contact')"
        />
        <span v-if="errors.org_contact" class="error">
          {{ $t("errors.registration.org_contact") }}
        </span>
      </div>
      <div class="input-wrapper">
        <InputView
          v-model="userLocal.usr_pr_text"
          type="textarea"
          :label="$t('main.pr') + (type ? ' *' : '')"
          @input="updateUser('usr_pr_text')"
        />
        <span v-if="errors.usr_org_contact_person" class="error">
          {{ $t("errors.registration.prError") }}
        </span>
      </div>
    </div>
    <div class="action">
      <router-link
        :to="{
          name: 'RegisterPage3',
          params: { lang: $i18n.locale },
          query: { ...$route.query }
        }"
        class="btn dark-blue"
      >
        {{ $t("register.next") }}
      </router-link>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.register-subpage {
  .btn {
    width: fit-content;
    padding: 10px 30px;
    margin: 20px 0;

    text-decoration: none;

    @media screen and (max-width: 768px) {
      width: inherit;
    }
  }
  .action {
    text-align: left;
  }
  .error {
    color: $red-700;
  }
  .inputs {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 480px;
    .input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 3px;
      align-items: flex-start;
      .dropdown-wrapper {
        width: 100%;
      }
      .file-display {
        margin: 20px 0;
      }
    }
    .questionmark-wrap {
      text-align: left;
      margin: 20px 0;
      color: $blue-400;
    }
    .checkbox-wrapper {
      display: flex;
      gap: 5px;
      align-items: flex-start;
      text-align: left;
      a {
        color: $light-blue-500;
      }
    }
  }
}
</style>
